import { Link } from 'react-router-dom';
import { dailyContestEntries } from '@/mocks/siteData';

export default function DailyContestSection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20stage%20or%20arena%20with%20dramatic%20warm%20spotlights%20and%20neon%20accent%20glows%2C%20atmospheric%20fog%2C%20concert%20or%20event%20lighting%20vibe%2C%20deep%20shadows%2C%20cinematic%20color%20grade%2C%20epic%20scale%2C%20no%20people%2C%20abstract%20light%20beams&width=1800&height=800&seq=daily-contest-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-foreground-950/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-8 lg:gap-16">
          <div className="lg:max-w-md">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-500/20 rounded-full mb-5">
              <i className="ri-fire-fill text-accent-400 text-sm"></i>
              <span className="text-accent-300 text-xs font-medium">每日12:00更新</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 leading-tight">
              每日大赛
            </h2>
            <p className="text-background-50/60 text-sm md:text-base mt-4 leading-relaxed max-w-sm">
              每天精选最劲爆的5条爆料话题，投出你的一票，决定今天谁是最强瓜王
            </p>
            <Link
              to="/category/daily-contest"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-background-50 hover:bg-background-100 text-foreground-950 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap group"
            >
              立即投票
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div className="space-y-3">
              {dailyContestEntries.map((entry) => (
                <Link
                  key={entry.id}
                  to={`/article/${entry.id}`}
                  className="flex items-center gap-4 p-4 rounded-xl bg-background-50/5 hover:bg-background-50/10 border border-background-50/8 hover:border-background-50/15 transition-all duration-200 cursor-pointer group"
                >
                  <div className={`w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full text-sm font-bold font-heading ${
                    entry.rank === 1
                      ? 'bg-secondary-500 text-foreground-950'
                      : entry.rank === 2
                      ? 'bg-foreground-300 text-foreground-950'
                      : entry.rank === 3
                      ? 'bg-foreground-400 text-foreground-950'
                      : 'bg-foreground-600 text-background-50'
                  }`}>
                    {entry.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-background-50/90 font-medium text-sm md:text-base truncate group-hover:text-accent-300 transition-colors">
                      {entry.title}
                    </p>
                  </div>
                  <div className="flex items-center gap-1.5 text-background-50/50 text-xs whitespace-nowrap">
                    <span className="hidden sm:inline">{entry.votes > 10000 ? `${(entry.votes / 10000).toFixed(1)}万` : entry.votes} 票</span>
                    <i className={`text-sm ${entry.trend === 'up' ? 'ri-arrow-up-line text-accent-400' : 'ri-arrow-down-line text-primary-400'}`}></i>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}